export default "__VITE_ASSET__b3dc7e73__"